module.exports = __webpack_public_path__ + "img/Wapp.ad0db251.svg";